import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-rax-border/50 bg-rax-bg">
      <div className="mx-auto max-w-7xl px-6 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="/assets/rax-logo.png"
              alt="RAX Protocol"
              className="mb-4 h-7 w-auto"
            />
            <p className="max-w-sm text-sm leading-relaxed text-rax-body">
              Institutional-grade DeFi risk intelligence and AI-driven allocation infrastructure.
              Autonomous capital management, protocol-grade vaults, and real-time analytics across chains.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="https://x.com/raxprotocol"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-lg border border-rax-border/60 bg-rax-card/30 transition-all hover:border-rax-border hover:bg-rax-card/50"
                data-testid="footer-twitter"
              >
                <img src="/x.svg" alt="X" className="h-3.5 w-3.5" />
              </a>
              <a
                href="https://t.me/raxprotocol"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-lg border border-rax-border/60 bg-rax-card/30 transition-all hover:border-rax-border hover:bg-rax-card/50"
                data-testid="footer-telegram"
              >
                <img src="/telegram.svg" alt="Telegram" className="h-3.5 w-3.5" />
              </a>
              <a
                href="https://discord.gg/pcHDVySGnc"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-lg border border-rax-border/60 bg-rax-card/30 transition-all hover:border-rax-border hover:bg-rax-card/50"
                data-testid="footer-discord"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286z"/></svg>
              </a>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h4 className="mb-4 font-heading text-xs font-semibold uppercase tracking-wider text-rax-heading">
              Resources
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://docs.raxprotocol.xyz/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-rax-body transition-colors hover:text-rax-cyan"
                  data-testid="footer-docs-link"
                >
                  Docs
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/rax-protocol"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-rax-body transition-colors hover:text-rax-cyan"
                  data-testid="footer-github-link"
                >
                  GitHub
                </a>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-sm text-rax-body transition-colors hover:text-rax-cyan"
                  data-testid="footer-terms-link"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-rax-body transition-colors hover:text-rax-cyan"
                  data-testid="footer-privacy-link"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Product */}
          <div>
            <h4 className="mb-4 font-heading text-xs font-semibold uppercase tracking-wider text-rax-heading">
              Product
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://app.raxprotocol.xyz/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-rax-cyan transition-colors hover:text-rax-cyan/80 font-medium"
                  data-testid="footer-launch-app"
                >
                  Launch App
                </a>
              </li>
              <li>
                <a
                  href="https://x.com/raxprotocol"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-rax-body transition-colors hover:text-rax-cyan"
                  data-testid="footer-x-link"
                >
                  X (Twitter)
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/raxprotocol"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-rax-body transition-colors hover:text-rax-cyan"
                  data-testid="footer-telegram-link"
                >
                  Telegram
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 flex items-center justify-center border-t border-rax-border/30 pt-6">
          <span className="font-mono text-[11px] text-rax-body/40">
            &copy; {new Date().getFullYear()} RAX Protocol. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}
